import { BLOG_POSTS, BLOG_POST_ORDER } from '@/constants/blogPosts'
import { BLOG_CATEGORY_BY_ID, getCategoryBySlug } from '@/constants/blogCategories'

export const POSTS_PER_PAGE = 10

export function formatBlogDate(isoDate) {
	if (!isoDate) return ''
	const months = [
		'January',
		'February',
		'March',
		'April',
		'May',
		'June',
		'July',
		'August',
		'September',
		'October',
		'November',
		'December',
	]
	const [year, month, day] = isoDate.split('-').map((n) => Number(n))
	return `${months[month - 1]} ${day}, ${year}`
}

export function buildPostPath(slug) {
	return `/${slug}/`
}

export function getPostBySlug(slug) {
	return Object.values(BLOG_POSTS).find((p) => p.slug === slug) || null
}

/** 仅 gbwhatpro.org 飞书 Phase 3 列出的文章（不展示矩阵里其它站的多余条目） */
export function getSiteBlogPosts() {
	const list = BLOG_POST_ORDER.map((slug) => BLOG_POSTS[slug]).filter(Boolean)
	return list.sort((a, b) => {
		const da = a.publishedAt || ''
		const db = b.publishedAt || ''
		if (da !== db) return db.localeCompare(da)
		return BLOG_POST_ORDER.indexOf(a.slug) - BLOG_POST_ORDER.indexOf(b.slug)
	})
}

export function getAllPostsSorted() {
	const list = Object.values(BLOG_POSTS)
	return list.sort((a, b) => {
		const da = a.publishedAt || ''
		const db = b.publishedAt || ''
		if (da !== db) return db.localeCompare(da)
		return (BLOG_POST_ORDER.indexOf(a.slug) - BLOG_POST_ORDER.indexOf(b.slug))
	})
}

export function getPostsByCategory(categoryId) {
	return getSiteBlogPosts().filter((p) => p.categoryId === categoryId)
}

export function paginatePosts(list, page, pageSize = POSTS_PER_PAGE) {
	const total = list.length
	const totalPages = Math.max(1, Math.ceil(total / pageSize))
	const safePage = Math.min(Math.max(1, page), totalPages)
	const start = (safePage - 1) * pageSize
	return {
		items: list.slice(start, start + pageSize),
		page: safePage,
		totalPages,
		total,
	}
}

export function getLatestPosts(limit = 5, excludeSlug = null) {
	return getSiteBlogPosts()
		.filter((p) => p.slug !== excludeSlug)
		.slice(0, limit)
}

export function getAdjacentPosts(slug) {
	const order = BLOG_POST_ORDER.length
		? BLOG_POST_ORDER.filter((s) => BLOG_POSTS[s])
		: getAllPostsSorted().map((p) => p.slug)
	const idx = order.indexOf(slug)
	if (idx === -1) return { prev: null, next: null }
	return {
		prev: idx > 0 ? getPostBySlug(order[idx - 1]) : null,
		next: idx < order.length - 1 ? getPostBySlug(order[idx + 1]) : null,
	}
}

export function getCategoryForPost(post) {
	return BLOG_CATEGORY_BY_ID[post.categoryId] || null
}

export { getCategoryBySlug }
